import { Service } from '@/tools'
export class externalService<T extends TProcure.TExternal> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TProcure.TExternal}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  // 新增库存转移单并提交 /api/procure/require/external/v1/addTransfer
  addTransfer = <K extends T['ApiAddTransfer']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAddTransfer', data, '操作成功')
}
